// extracted by mini-css-extract-plugin
module.exports = {"modal-overlay":"_2hriZF","scroll-on-body":"_3FxkWS","active":"_2rbIyg","modal-dialog":"_2QfC02","modal-content":"_2MlkI1","close-btn":"_2doB4z"};